import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'src/Components'
import { IconBell } from 'src/Components/shared/Icon'
import { ConfirmAlertModal } from './ConfirmAlertModal'
import { toggleAuthModal } from 'src/actions/homeSearchAuthModal'
import { selectClientIsGuest } from 'src/store/selectors/client'

export const ConfirmAlertButton = () => {
  const dispatch = useDispatch()
  const clientIsGuest = useSelector(selectClientIsGuest)
  const [showModal, setShowModal] = useState(false)

  const showConfirmModalOrAuth = () =>
    clientIsGuest ? dispatch(toggleAuthModal(true)) : setShowModal(true)

  return (
    <>
      <Button
        onClick={() => showConfirmModalOrAuth()}
        data-qa='confirm-listing-alert-button'
        aria-label='set listing alert'
        iconStart={IconBell}
        compact
      >
        <FormattedMessage
          id='HomeSearch.listings.alerts.button_off'
          defaultMessage='Alerts off'
        />
      </Button>
      {showModal && <ConfirmAlertModal hideAlert={() => setShowModal(false)} />}
    </>
  )
}
